import React, { useState, useEffect, useContext, useCallback } from 'react';
import { AppDataContext } from 'contexts/appData';
import { ModalsContext } from 'contexts/modals';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FocusError } from 'components';
import { Functions } from '../../../libs';
import { Async as AsyncSelect } from 'react-select-virtualized'
import { UserContext } from '../../../contexts/user';


const AddressForm = (props) => {
	const { langs, api, appData } = useContext(AppDataContext);
	const { callResponse } = useContext(ModalsContext);
	const {user} = useContext(UserContext)

	let statusCode = false;

	const getValidationSchema = (validationSchema = {}) => {
		let validationSchemaList = {
			LocID: Yup.number()
				.required(`${langs.LocExTitle}`),
			FullName: Yup.string()
				.min(2, `${langs.WriteFullName}`)
				.max(50, `${langs.WriteFullName}`)
				.required(`${langs.WriteFullName}`),
			Address: Yup.string()
			    .min(5, `${langs.WriteDetLoc}`)
			    .max(200, `${langs.WriteDetLoc}`)
			    .required(`${langs.WriteDetLoc}`),
			PersonalNumber: Yup.string()
				.matches(/^[0-9]+$/, `${langs.IncorrectFormat}`)
				.test('len', `${langs.IncorrectFormat}`, 
					(val) => val && ((parseInt(props.Type) === 0 && val.length === 11) || (parseInt(props.Type) === 1 && val.length >= 9 && val.length <= 11))
				) 
				.required(`${langs.WritePersonalNumber}`),
			Phone: Yup.string()
				.matches(/^[0-9]+$/, `${langs.IncorrectFormat}`)
				.test('len', `${langs.IncorrectFormatOfPhoneNumber}`, val => val && val.length === 9)
				.required(`${langs.WriteYourPhone}`),
			SecondPhone: Yup.string().notRequired()
				.matches(/^[0-9]+$/, `${langs.IncorrectFormat}`)
				// .test('len', `${langs.IncorrectFormatOfPhoneNumber}`, val => val && val.length === 9)
		}
		return Yup.object().shape({...validationSchema, ...validationSchemaList })
}

	const [config, setConfig] = useState({
		id: 'address',
		title: `${langs.Address}`,
		initialValues: {
			LocID: props.item && props.item.city ? props.item.city : '',
			FullName: props.item && props.item.fullname ? props.item.fullname : '',
			Address: props.item && props.item.address ? props.item.address : '',
			PersonalNumber: props.item && props.item.personalNumber ? props.item.personalNumber : '',
			// Phone: props.item && props.item.phone ? props.item.phone : '',
			Phone: user?.Phone ?? '',
			SecondPhone: props.item && props.item.secondPhone ? props.item.secondPhone : '',
		},
		validationSchema:getValidationSchema(),
		enableReinitialize: true,
	});

	const handleAddress = (values, { setSubmitting, resetForm }) => {
		setSubmitting(true);
		const addressAction = async () => {
			let action;
			if (props.item.id) {
				action = await api.putAddressUpdate(props.item.id, values);
			} else {
				values["UserTypeID"] = [0, 1].includes(parseInt(props.Type)) ? parseInt(props.Type) : 0
				action = await api.postAddAddress(values);
			}

			statusCode = action.statusCode === 200 ? true : false
			callResponse({
				statusCode: statusCode,
				statusMessage:
					typeof action.statusMessage === 'string'
						? action.statusMessage
						: Object.values(action.statusMessage).map((error) => <div key={error}>{error}</div>)
			});
			setSubmitting(false);
			if (action.statusCode === 200) {
				if (props.item.id) {
					props.actionAfterEdit(props.item.id, values)
				} else {
					resetForm();
					props.actionAfterAdd(action.data, values)
				}
			}
		};
		addressAction();
	}

  const loadOptions = (inputValue) => {
    const filtered = appData.Locs.fullList.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    return (filtered);
  };

  const debouncedLoadOptions = useCallback(
    Functions.debounce((inputValue, callback) => {
      const results = loadOptions(inputValue);
      callback(results);
    }, 300),
    []
  );

	useEffect(() => {
		if (['0', '1'].includes(props.Type)) {
			setConfig({ ...config, validationSchema: getValidationSchema() })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.Type])
	return (
		<>
		<Formik {...config} onSubmit={handleAddress}>
			{
				({ values, errors, status, touched, isSubmitting, handleChange, setFieldValue }) => {
					const checkNumber = (e) => {
		        e.preventDefault();
		        const { value } = e.target;
		        if (/^\d*\.?\d*$/.test(value.toString())) {
		          setFieldValue(e.target.name, value);
		        }
		      }

					return(
						<Form autoComplete="off">
							<div className="add-address-content right-side border-radius-sm bg-white">
								<div className="p-24px p-md-40px">
									<div className="mb-35px">
										<h1 className="text-dark-market-color font-size-14 font-weight-bold">
											{props.item.id ? `${langs.EditUserAddress}` : `${langs.AddNewUserAddress}`}
										</h1>
									</div>
									<div className="row mt-24px">
										<div className="col-md-12">
											<div className="form-group m-0">
												<label className="font-size-12 text-text_label">
													{parseInt(props.Type) > 0 ? langs.OrgName : `${langs.Name} ${langs.SurName}`}
													<span className="text-blue">*</span>
												</label>
												<Field className="form-control font-base" name="FullName" type="text" />
												<ErrorMessage name="FullName" component="label" className="error text-danger" />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6 mt-15px">
											<div className="form-group m-0">
												<label className="font-size-12 text-text_label">{langs.LocEx} <span className="text-blue">*</span></label>
												<AsyncSelect
                          name="LocID"
                          className="border-radius-sm bg-white"
                          classNamePrefix="virtualized-select "
                          optionHeight={38}
                          placeholder=""
                          isClearable={false}
                          noOptionsMessage={() => "No values available!"}
                          cacheOptions
                          loadOptions={debouncedLoadOptions}
                          defaultOptions={appData.Locs.fullList}
                          value={appData.Locs.fullList.find(el => parseInt(el.value) === parseInt(values.LocID)) ?? ''}
                          onChange={option => {
                             handleChange("LocID")(option.value.toString());
                           }}
												/>
												<ErrorMessage name="LocID" component="label" className="error text-danger" />
											</div>
										</div>
										<div className="col-md-6 mt-15px">
											<div className="form-group m-0">
												<label className="font-size-12 text-text_label">
													{parseInt(props.Type) > 0 ? `${langs.IDCode}` : langs.PersonalNumber}
													<span className="text-blue">*</span>
												</label>
												<Field className="form-control font-base" name="PersonalNumber" type="text" maxLength="11" onChange={(e) => {checkNumber(e)}} />
												<ErrorMessage name="PersonalNumber" component="label" className="error text-danger" />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6 mt-15px">
											<div className="form-group m-0">
												<label className="font-size-12 text-text_label">{langs.PhoneNumber}  <span className="text-blue">*</span></label>
												<Field className="form-control font-base" name="Phone" type="text" disabled maxLength="9" onChange={(e) => {checkNumber(e)}} />
												<ErrorMessage name="Phone" component="label" className="error text-danger" />
											</div>

											<div style={{display:'flex', marginTop:8}}>
												<svg style={{minWidth:22, marginRight:6}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path d="M10.0013 1.6665C5.4013 1.6665 1.66797 5.39984 1.66797 9.99984C1.66797 14.5998 5.4013 18.3332 10.0013 18.3332C14.6013 18.3332 18.3346 14.5998 18.3346 9.99984C18.3346 5.39984 14.6013 1.6665 10.0013 1.6665ZM10.8346 14.1665H9.16797V9.1665H10.8346V14.1665ZM10.8346 7.49984H9.16797V5.83317H10.8346V7.49984Z" fill="#2B6ADE"/>
												</svg>
												<div style={{fontSize:12}}>
													ამ ნომერზე მიიღებ შეკვეთის დამადასტურებელ კოდს
												</div>
											</div>
										</div>
										<div className="col-md-6 mt-15px">
											<div className="form-group m-0">
												<label className="font-size-12 text-text_label">{langs.NM_SecondPhoneNumber}</label>
												<Field className="form-control font-base" name="SecondPhone" type="text" maxLength="9" onChange={(e) => {checkNumber(e)}} />
												<ErrorMessage name="SecondPhone" component="label" className="error text-danger" />
											</div>
										</div>
									</div>
									<div className="row mt-15px">
										<div className="col-md-12">
											<div className="form-group m-0">
												<label className="font-size-12 text-text_label">{langs.Address}   <span className="text-blue">*</span></label>
												<Field className="form-control font-base" name="Address" type="text" />
												<ErrorMessage name="Address" component="label" className="error text-danger" />
											</div>
										</div>
									</div>
								</div>
								<div className="footer-btn p-25px">
									<div className="col-md-12 d-flex justify-content-between">
										<button type="reset" className="btn btn-no-outline hover-underline  font-size-12 text-blue-gray font-base font-weight-normal p-0" >
											{langs.Cancel}
										</button>
										<button type="submit" className="btn bg-gradient border-radius-sm font-size-13 font-weight-bold text-white" disabled={isSubmitting}>{langs.Save}</button>
									</div>
								</div>
							</div>
							<FocusError />
						</Form>
					)
				}
			}
		</Formik>
		</>
	)
} 

export default AddressForm
